import resource from 'resource-axios'
import axios from 'axios'

const _base = 'tours'
const customActions = {
  remove: params => axios.delete(`${_base}?id=eq.${params.id}`),
  update: (params,payload) => axios.patch(`${_base}?id=eq.${params.id}`, payload)
}
export const tours = resource('/tours', customActions, axios)
